import { ref } from "vue";
export function useUniqueLabelError(workflowStateStore, label) {
    const error = ref(null);
    if (label && workflowStateStore.workflowOutputs[label]) {
        error.value = `Duplicate label ${label}. Please fix this before saving the workflow.`;
    }
    return error;
}
